/// EMAIL VERIFICATION
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE'
export const REISSUE_TOKEN_REQUEST = 'REISSUE_TOKEN_REQUEST'
export const REISSUE_TOKEN_SUCCESS = 'REISSUE_TOKEN_SUCCESS'
export const REISSUE_TOKEN_FAILURE = 'REISSUE_TOKEN_FAILURE'

/// USER REGISTRATION
export const REGISTER_USER = 'REGISTER_USER'
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE'
export const VERIFY_EMAIL_UNIQUE_REQUEST = 'VERIFY_EMAIL_UNIQUE_REQUEST'
export const VERIFY_EMAIL_UNIQUE_SUCCESS = 'VERIFY_EMAIL_UNIQUE_SUCCESS'
export const VERIFY_EMAIL_UNQIUE_FAILURE = 'VERIFY_EMAIL_UNQIUE_FAILURE'
export const VERIFY_USERNAME_UNIQUE_REQUEST = 'VERIFY_USERNAME_UNIQUE_REQUEST'
export const VERIFY_USERNAME_UNIQUE_SUCCESS = 'VERIFY_USERNAME_UNIQUE_SUCCESS'
export const VERIFY_USERNAME_UNQIUE_FAILURE = 'VERIFY_USERNAME_UNQIUE_FAILURE'

/// LICENSES: APPRAISER ID VERIFICATION
export const GET_LICENSE_REQUEST = 'GET_LICENSE_REQUEST'
export const GET_LICENSE_SUCCESS = 'GET_LICENSE_SUCCESS'
export const GET_LICENSE_FAILURE = 'GET_LICENSE_FAILURE'
export const CLEAR_INVITEE_LICENSES = 'CLEAR_INVITEE_LICENSES'

/// CURRENT USER
export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST'
export const NO_CURRENT_USER = 'NO_CURRENT_USER'
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS'
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE'
export const CURRENT_USER_ALREADY_SET = 'CURRENT_USER_ALREADY_SET'
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'
export const CLEAR_CURRENT_USER_STATUS = 'CLEAR_CURRENT_USER_STATUS'
export const CURRENT_USER_REGISTRATION_COMPLETE = 'CURRENT_USER_REGISTRATION_COMPLETE'
export const UPDATE_APPRAISER_REQUEST = 'UPDATE_APPRAISER_REQUEST'
export const UPDATE_APPRAISER_SUCCESS = 'UPDATE_APPRAISER_SUCCESS'
export const UPDATE_APPRAISER_FAILURE = 'UPDATE_APPRAISER_FAILURE'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const UNSET_CURRENT_USER = 'UNSET_CURRENT_USER'
export const CHANGE_USER_ROLE = 'CHANGE_USER_ROLE'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS'
export const GET_INVITATIONS_SUCCESS = 'GET_INVITATIONS_SUCCESS'
export const VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS'
export const UPDATE_INVITATIONS_REQUEST = 'UPDATE_INVITATIONS_REQUEST'
export const UPDATE_INVITATIONS_SUCCESS = 'UPDATE_INVITATIONS_SUCCESS'
export const UPDATE_INVITATIONS_FAILURE = 'UPDATE_INVITATIONS_FAILURE'
export const SEND_BOX_NOTIFICATION = 'SEND_BOX_NOTIFICATION'
export const CLEAR_BOX_NOTIFICATION = 'CLEAR_BOX_NOTIFICATION'
export const CLEAR_ALL_BOX_NOTIFICATIONS = 'CLEAR_ALL_BOX_NOTIFICATIONS'
export const GET_COMPANY_APPRAISERS_REQUEST = 'GET_COMPANY_APPRAISERS_REQUEST'
export const GET_COMPANY_APPRAISERS_SUCCESS = 'GET_COMPANY_APPRAISERS_SUCCESS'
export const GET_COMPANY_APPRAISERS_FAILURE = 'GET_COMPANY_APPRAISERS_FAILURE'
export const CREATE_COMPANY_CLIENT_REQUEST = 'CREATE_COMPANY_CLIENT_REQUEST'
export const CREATE_COMPANY_CLIENT_SUCCESS = 'CREATE_COMPANY_CLIENT_SUCCESS'
export const CREATE_COMPANY_CLIENT_FAILURE = 'CREATE_COMPANY_CLIENT_FAILURE'
export const VERIFY_APPRAISER_REQUEST = 'VERIFY_APPRAISER_REQUEST'
export const VERIFY_APPRAISER_SUCCESS = 'VERIFY_APPRAISER_SUCCESS'
export const VERIFY_APPRAISER_FAILURE = 'VERIFY_APPRAISER_FAILURE'
export const SUBMIT_UPDATED_CONSENT_REQUEST = 'SUBMIT_UPDATED_CONSENT_REQUEST'
export const SUBMIT_UPDATED_CONSENT_SUCCESS = 'SUBMIT_UPDATED_CONSENT_SUCCESS'
export const SUBMIT_UPDATED_CONSENT_FAILURE = 'SUBMIT_UPDATED_CONSENT_FAILURE'
export const UPDATE_APPRAISER_COVERAGE_REQUEST = 'UPDATE_APPRAISER_COVERAGE_REQUEST'
export const UPDATE_APPRAISER_COVERAGE_SUCCESS = 'UPDATE_APPRAISER_COVERAGE_SUCCESS'
export const UPDATE_APPRAISER_COVERAGE_FAILURE = 'UPDATE_APPRAISER_COVERAGE_FAILURE'

/// Upload License + Insurance
export const CHANGE_USER_DOCS_REQUEST = 'CHANGE_USER_DOCS_REQUEST'
export const CHANGE_USER_DOCS_SUCCESS = 'CHANGE_USER_DOCS_SUCCESS'

export const UPLOAD_USER_DOCS_REQUEST = 'UPLOAD_USER_DOCS_REQUEST'
export const UPLOAD_USER_DOCS_SUCCESS = 'UPLOAD_USER_DOCS_SUCCESS'
export const UPLOAD_USER_DOCS_FAILURE = 'UPLOAD_USER_DOCS_FAILURE'

/// PASSWORD RESET
export const SEND_RESET_PASSWORD_EMAIL_REQUEST = 'SEND_RESET_PASSWORD_EMAIL_REQUEST'
export const SEND_RESET_PASSWORD_EMAIL_SUCCESS = 'SEND_RESET_PASSWORD_EMAIL_SUCCESS'
export const SEND_RESET_PASSWORD_EMAIL_FAILURE = 'SEND_RESET_PASSWORD_EMAIL_FAILURE'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

/// CURRENT USER CLIENT
export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE'
export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST'
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS'
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE'
export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST'
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS'
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE'

/// CURRENT USER CANNED COMMENTS
export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE'
export const UPDATE_COMMENT_REQUEST = 'UPDATE_COMMENT_REQUEST'
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS'
export const UPDATE_COMMENT_FAILURE = 'UPDATE_COMMENT_FAILURE'
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE'

/// REPORTS
export const UPLOAD_REPORT_REQUEST = 'UPLOAD_REPORT_REQUEST'
export const UPLOAD_REPORT_SUCCESS = 'UPLOAD_REPORT_SUCCESS'
export const UPLOAD_REPORT_FAILURE = 'UPLOAD_REPORT_FAILURE'
export const START_REPORT_SUBMISSION = 'START_REPORT_SUBMISSION'
export const END_REPORT_SUBMISSION = 'END_REPORT_SUBMISSION'

/// LISTINGS
export const GET_MATCHED_LISTINGS_REQUEST = 'GET_MATCHED_LISTINGS_REQUEST'
export const GET_MATCHED_LISTINGS_SUCCESS = 'GET_MATCHED_LISTINGS_SUCCESS'
export const GET_MATCHED_LISTINGS_FAILURE = 'GET_MATCHED_LISTINGS_FAILURE'

export const POST_CHARGE_REQUEST = 'POST_CHARGE_REQUEST'
export const POST_CHARGE_FAILURE = 'POST_CHARGE_FAILURE'
export const POST_CHARGE_SUCCESS = 'POST_CHARGE_SUCCESS'

export const GET_FULL_LISTING_REQUEST = 'GET_FULL_LISTING_REQUEST'
export const GET_FULL_LISTING_SUCCESS = 'GET_FULL_LISTING_SUCCESS'
export const GET_FULL_LISTING_FAILURE = 'GET_FULL_LISTING_FAILURE'

/// ACCOUNTING
export const GET_ACCOUNTING_DATA_REQUEST = 'GET_ACCOUNTING_DATA_REQUEST'
export const GET_ACCOUNTING_DATA_SUCCESS = 'GET_ACCOUNTING_DATA_SUCCESS'
export const GET_ACCOUNTING_DATA_FAILURE = 'GET_ACCOUNTING_DATA_FAILURE'
export const GET_ACCOUNTING_SUMMARY_REQUEST = 'GET_ACCOUNTING_SUMMARY_REQUEST'
export const GET_ACCOUNTING_SUMMARY_SUCCESS = 'GET_ACCOUNTING_SUMMARY_SUCCESS'
export const GET_ACCOUNTING_SUMMARY_FAILURE = 'GET_ACCOUNTING_SUMMARY_FAILURE'
export const GET_ACCOUNTING_DATA_FOR_EXPORT_REQUEST = 'GET_ACCOUNTING_DATA_FOR_EXPORT_REQUEST'
export const GET_ACCOUNTING_DATA_FOR_EXPORT_SUCCESS = 'GET_ACCOUNTING_DATA_FOR_EXPORT_SUCCESS'
export const GET_ACCOUNTING_DATA_FOR_EXPORT_FAILURE = 'GET_ACCOUNTING_DATA_FOR_EXPORT_FAILURE'

/// SHELL USER ACTIONS
export const GET_SHELL_USER_REQUEST = 'GET_SHELL_USER_REQUEST'
export const GET_SHELL_USER_REQUEST_SUCCESS = 'GET_SHELL_USER_REQUEST_SUCCESS'
export const GET_SHELL_USER_REQUEST_FAILURE = 'GET_SHELL_USER_REQUEST_FAILURE'
export const SHELL_USER_ALREADY_SET = 'SHELL_USER_ALREADY_SET'
export const REGISTER_SHELL_USER_REQUEST = 'REGISTER_SHELL_USER_REQUEST'
export const REGISTER_SHELL_USER_REQUEST_SUCCESS = 'REGISTER_SHELL_USER_REQUEST_SUCCESS'
export const REGISTER_SHELL_USER_REQUEST_FAILURE = 'REGISTER_SHELL_USER_REQUEST_FAILURE'

/// INVITATIONS
export const CREATE_COMPANY_INVITATIONS_REQUEST = 'CREATE_COMPANY_INVITATIONS'
export const CREATE_COMPANY_INVITATIONS_SUCCESS = 'CREATE_COMPANY_INVITATIONS_SUCCESS'
export const CREATE_COMPANY_INVITATIONS_FALURE = 'CREATE_COMPANY_INVITATIONS_FALURE'
export const RESEND_COMPANY_INVITATIONS_REQUEST = 'RESEND_COMPANY_INVITATIONS_REQUEST'
export const RESEND_COMPANY_INVITATIONS_FAILURE = 'RESEND_COMPANY_INVITATIONS_FAILURE'
export const RESEND_COMPANY_INVITATIONS_SUCCESS = 'RESEND_COMPANY_INVITATIONS_SUCCESS'
export const DELETE_COMPANY_INVITATIONS_REQUEST = 'DELETE_COMPANY_INVITATIONS_REQUEST'
export const DELETE_COMPANY_INVITATIONS_SUCCESS = 'DELETE_COMPANY_INVITATIONS_SUCCESS'
export const DELETE_COMPANY_INVITATIONS_FALURE = 'DELETE_COMPANY_INVITATIONS_FALURE'

/// COMPANY UPDAting
export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST'
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE'
export const UPLOAD_COMPANY_EO_REQUEST = 'UPLOAD_COMPANY_EO_REQUEST'
export const UPLOAD_COMPANY_EO_SUCCESS = 'UPLOAD_COMPANY_EO_SUCCESS'
export const UPLOAD_COMPANY_EO_FAILURE = 'UPLOAD_COMPANY_EO_FAILURE'
export const UPDATE_USER_COMPANY_ROLE_REQUEST = 'UPDATE_USER_COMPANY_ROLE_REQUEST'
export const UPDATE_USER_COMPANY_ROLE_SUCCESS = 'UPDATE_USER_COMPANY_ROLE_SUCCESS'
export const UPDATE_USER_COMPANY_ROLE_FAILURE = 'UPDATE_USER_COMPANY_ROLE_FAILURE'
export const REMOVE_USER_FROM_COMPANY_REQUEST = 'REMOVE_USER_FROM_COMPANY_REQUEST'
export const REMOVE_USER_FROM_COMPANY_SUCCESS = 'REMOVE_USER_FROM_COMPANY_SUCCESS'
export const REMOVE_USER_FROM_COMPANY_FAILURE = 'REMOVE_USER_FROM_COMPANY_FAILURE'

/// ORDERS
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE'
export const GET_COMPANY_ORDERS_REQUEST = 'GET_COMPANY_ORDERS_REQUEST'
export const GET_COMPANY_ORDERS_SUCCESS = 'GET_COMPANY_ORDERS_SUCCESS'
export const GET_COMPANY_ORDERS_FAILURE = 'GET_COMPANY_ORDERS_FAILURE'
export const ASSIGN_ORDER_REQUEST = 'ASSIGN_ORDER_REQUEST'
export const ASSIGN_ORDER_SUCCESS = 'ASSIGN_ORDER_SUCCESS'
export const ASSIGN_ORDER_FAILURE = 'ASSIGN_ORDER_FAILURE'
export const ACCEPT_ORDER_REQUEST = 'ACCEPT_ORDER_REQUEST'
export const ACCEPT_ORDER_SUCCESS = 'ACCEPT_ORDER_SUCCESS'
export const ACCEPT_ORDER_FAILURE = 'ACCEPT_ORDER_FAILURE'
export const DENY_ORDER_REQUEST = 'DENY_ORDER_REQUEST'
export const DENY_ORDER_SUCCESS = 'DENY_ORDER_SUCCESS'
export const DENY_ORDER_FAILURE = 'DENY_ORDER_FAILURE'
export const CREATE_MANUAL_ORDER_REQUEST = 'CREATE_MANUAL_ORDER_REQUEST'
export const CREATE_MANUAL_ORDER_SUCCESS = 'CREATE_MANUAL_ORDER_SUCCESS'
export const CREATE_MANUAL_ORDER_FAILURE = 'CREATE_MANUAL_ORDER_FAILURE'
export const EDIT_MANUAL_ORDER_REQUEST = 'EDIT_MANUAL_ORDER_REQUEST'
export const EDIT_MANUAL_ORDER_SUCCESS = 'EDIT_MANUAL_ORDER_SUCCESS'
export const EDIT_MANUAL_ORDER_FAILURE = 'EDIT_MANUAL_ORDER_FAILURE'
export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST'
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS'
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE'
export const APPROVE_ORDER_REQUEST = 'APPROVE_ORDER_REQUEST'
export const APPROVE_ORDER_SUCCESS = 'APPROVE_ORDER_SUCCESS'
export const APPROVE_ORDER_FAILURE = 'APPROVE_ORDER_FAILURE'
export const APPROVE_SUBMISSION_V2_REQUEST = 'APPROVE_SUBMISSION_V2_REQUEST'
export const APPROVE_SUBMISSION_V2_FAILURE = 'APPROVE_SUBMISSION_V2_FAILURE'
export const APPRAISER_DENY_ORDER_REQUEST = 'APPRAISER_DENY_ORDER_REQUEST'
export const APPRAISER_DENY_ORDER_SUCCESS = 'APPRAISER_DENY_ORDER_SUCCESS'
export const APPRAISER_DENY_ORDER_FAILURE = 'APPRAISER_DENY_ORDER_FAILURE'
export const SET_ORDER_INSPECTION_DATE_REQUEST = 'SET_ORDER_INSPECTION_DATE_REQUEST'
export const SET_ORDER_INSPECTION_DATE_SUCCESS = 'SET_ORDER_INSPECTION_DATE_SUCCESS'
export const SET_ORDER_INSPECTION_DATE_FAILURE = 'SET_ORDER_INSPECTION_DATE_FAILURE'
export const ORDER_INSPECTION_COMPLETE_REQUEST = 'ORDER_INSPECTION_COMPLETE_REQUEST'
export const ORDER_INSPECTION_COMPLETE_SUCCESS = 'ORDER_INSPECTION_COMPLETE_SUCCESS'
export const ORDER_INSPECTION_COMPLETE_FAILURE = 'ORDER_INSPECTION_COMPLETE_FAILURE'
export const APPRAISER_ACCEPT_ORDER_REQUEST = 'APPRAISER_ACCEPT_ORDER_REQUEST'
export const APPRAISER_ACCEPT_ORDER_SUCCESS = 'APPRAISER_ACCEPT_ORDER_SUCCESS'
export const APPRAISER_ACCEPT_ORDER_FAILURE = 'APPRAISER_ACCEPT_ORDER_FAILURE'
export const ORDER_OFFER_REQUEST = 'ORDER_OFFER_REQUEST'
export const ORDER_OFFER_SUCCESS = 'ORDER_OFFER_SUCCESS'
export const ORDER_OFFER_FAILURE = 'ORDER_OFFER_FAILURE'
export const FEE_ESCALATION_REQUEST = 'FEE_ESCALATION_REQUEST'
export const FEE_ESCALATION_SUCCESS = 'FEE_ESCALATION_SUCCESS'
export const FEE_ESCALATION_FAILURE = 'FEE_ESCALATION_FAILURE'
export const CANCEL_ORDER_REQUEST = 'CANCEL_ORDER_REQUEST'
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS'
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE'
export const GET_ORDER_BY_ID_REQUEST = 'GET_ORDER_BY_ID_REQUEST'
export const GET_ORDER_BY_ID_SUCCESS = 'GET_ORDER_BY_ID_SUCCESS'
export const GET_ORDER_BY_ID_FAILURE = 'GET_ORDER_BY_ID_FAILURE'
export const RESET_ACTIVE_ORDER = 'RESET_ACTIVE_ORDER'

// CONVERSATION
export const GET_CONVERSATION_BY_ORDER_ID_REQUEST = 'GET_CONVERSATION_BY_ORDER_ID_REQUEST'
export const GET_CONVERSATION_BY_ORDER_ID_SUCCESS = 'GET_CONVERSATION_BY_ORDER_ID_SUCCESS'
export const GET_CONVERSATION_BY_ORDER_ID_FAILURE = 'GET_CONVERSATION_BY_ORDER_ID_FAILURE'

// CONTACT INFO
export const GET_CONTACT_INFO_BY_ORDER_ID_REQUEST = 'GET_CONTACT_INFO_BY_ORDER_ID_REQUEST'
export const GET_CONTACT_INFO_BY_ORDER_ID_SUCCESS = 'GET_CONTACT_INFO_BY_ORDER_ID_SUCCESS'
export const GET_CONTACT_INFO_BY_ORDER_ID_FAILURE = 'GET_CONTACT_INFO_BY_ORDER_ID_FAILURE'

// OFFERS
export const GET_OFFERS_BY_ORDER_ID_REQUEST = 'GET_OFFERS_BY_ORDER_ID_REQUEST'
export const GET_OFFERS_BY_ORDER_ID_SUCCESS = 'GET_OFFERS_BY_ORDER_ID_SUCCESS'
export const GET_OFFERS_BY_ORDER_ID_FAILURE = 'GET_OFFERS_BY_ORDER_ID_FAILURE'

// SUBMISSIONS
export const GET_SUBMISSIONS_BY_ORDER_ID_REQUEST = 'GET_SUBMISSIONS_BY_ORDER_ID_REQUEST'
export const GET_SUBMISSIONS_BY_ORDER_ID_SUCCESS = 'GET_SUBMISSIONS_BY_ORDER_ID_SUCCESS'
export const GET_SUBMISSIONS_BY_ORDER_ID_FAILURE = 'GET_SUBMISSIONS_BY_ORDER_ID_FAILURE'

// REVISIONS
export const GET_REVISIONS_BY_ORDER_ID_REQUEST = 'GET_REVISIONS_BY_ORDER_ID_REQUEST'
export const GET_REVISIONS_BY_ORDER_ID_SUCCESS = 'GET_REVISIONS_BY_ORDER_ID_SUCCESS'
export const GET_REVISIONS_BY_ORDER_ID_FAILURE = 'GET_REVISIONS_BY_ORDER_ID_FAILURE'

export const UPDATE_COMPANY_CLIENT_REQUEST = 'UPDATE_COMPANY_CLIENT_REQUEST'
export const UPDATE_COMPANY_CLIENT_SUCCESS = 'UPDATE_COMPANY_CLIENT_SUCCESS'
export const UPDATE_COMPANY_CLIENT_FAILURE = 'UPDATE_COMPANY_CLIENT_FAILURE'
export const DELETE_COMPANY_CLIENT_REQUEST = 'DELETE_COMPANY_CLIENT_REQUEST'
export const DELETE_COMPANY_CLIENT_SUCCESS = 'DELETE_COMPANY_CLIENT_SUCCESS'
export const DELETE_COMPANY_CLIENT_FAILURE = 'DELETE_COMPANY_CLIENT_FAILURE'
export const EDIT_COMPANY_CLIENT_TAGS_REQUEST = 'EDIT_COMPANY_CLIENT_TAGS_REQUEST'
export const EDIT_COMPANY_CLIENT_TAGS_SUCCESS = 'EDIT_COMPANY_CLIENT_TAGS_SUCCESS'
export const EDIT_COMPANY_CLIENT_TAGS_FAILURE = 'EDIT_COMPANY_CLIENT_TAGS_FAILURE'

/// MESSAGING
export const CREATE_ORDER_MESSAGE_REQUEST = 'CREATE_ORDER_MESSAGE_REQUEST'
export const CREATE_ORDER_MESSAGE_SUCCESS = 'CREATE_ORDER_MESSAGE_SUCCESS'
export const CREATE_ORDER_MESSAGE_FAILURE = 'CREATE_ORDER_MESSAGE_FAILURE'
export const CREATE_COMPANY_ORDER_MESSAGE_REQUEST = 'CREATE_COMPANY_ORDER_MESSAGE_REQUEST'
export const CREATE_COMPANY_ORDER_MESSAGE_SUCCESS = 'CREATE_COMPANY_ORDER_MESSAGE_SUCCESS'
export const CREATE_COMPANY_ORDER_MESSAGE_FAILURE = 'CREATE_COMPANY_ORDER_MESSAGE_FAILURE'
export const MARK_MESSAGE_READ_REQUEST = 'MARK_MESSAGE_READ_REQUEST'
export const MARK_MESSAGE_READ_SUCCESS = 'MARK_MESSAGE_READ_SUCCESS'
export const MARK_MESSAGE_READ_FAILURE = 'MARK_MESSAGE_READ_FAILURE'


// EVAULT
export const CREATE_EVAULT_DOCUMENT_REQUEST = 'CREATE_EVAULT_DOCUMENT_REQUEST'
export const CREATE_EVAULT_DOCUMENT_FAILURE = 'CREATE_EVAULT_DOCUMENT_FAILURE'
export const CREATE_EVAULT_DOCUMENT_SUCCESS = 'CREATE_EVAULT_DOCUMENT_SUCCESS'
export const REMOVE_EVAULT_DOCUMENT_REQUEST = 'REMOVE_EVAULT_DOCUMENT_REQUEST'
export const REMOVE_EVAULT_DOCUMENT_FAILURE = 'REMOVE_EVAULT_DOCUMENT_FAILURE'
export const REMOVE_EVAULT_DOCUMENT_SUCCESS = 'REMOVE_EVAULT_DOCUMENT_SUCCESS'
export const CREATE_EVAULT_DOCUMENT_MODAL_SUCCESS = 'CREATE_EVAULT_DOCUMENT_MODAL_SUCCESS'
export const CREATE_EVAULT_DOCUMENT_MODAL_REQUEST = 'CREATE_EVAULT_DOCUMENT_MODAL_REQUEST'
export const CREATE_EVAULT_DOCUMENT_MODAL_FAILURE = 'CREATE_EVAULT_DOCUMENT_MODAL_FAILURE'
export const GET_EVAULT_REQUEST = 'GET_EVAULT_REQUEST'
export const GET_EVAULT_SUCCESS = 'GET_EVAULT_SUCCESS'
export const GET_EVAULT_FAILURE = 'GET_EVAULT_FAILURE'

export const UPDATE_REVISION_REQUEST = 'UPDATE_REVISION_REQUEST'
export const UPDATE_REVISION_SUCCESS = 'UPDATE_REVISION_SUCCESS'
export const UPDATE_REVISION_FAILURE = 'UPDATE_REVISION_FAILURE'

export const VERIFY_INVITATION_EMAILS_REQUEST = 'VERIFY_INVITATION_EMAILS_REQUEST'
export const VERIFY_INVITATION_EMAILS_SUCCESS = 'VERIFY_INVITATION_EMAILS_SUCCESS'
export const VERIFY_INVITATION_EMAILS_FAILURE = 'VERIFY_INVITATION_EMAILS_FAILURE'

// MAPS
export const GET_MAP_OVERLAY_REQUEST = 'GET_MAP_OVERLAY_REQUEST'
export const GET_MAP_OVERLAY_SUCCESS = 'GET_MAP_OVERLAY_SUCCESS'
export const GET_MAP_OVERLAY_FAILURE = 'GET_MAP_OVERLAY_FAILURE'

// INTEGRATION LINKAGE
export const CREATE_INTEGRATION_LINKAGE_REQUEST = 'CREATE_INTEGRATION_LINKAGE_REQUEST'
export const CREATE_INTEGRATION_LINKAGE_SUCCESS = 'CREATE_INTEGRATION_LINKAGE_SUCCESS'
export const CREATE_INTEGRATION_LINKAGE_FAILURE = 'CREATE_INTEGRATION_LINKAGE_FAILURE'
export const GET_INTEGRATION_LINKAGE_REQUEST = 'GET_INTEGRATION_LINKAGE_REQUEST'
export const GET_INTEGRATION_LINKAGE_SUCCESS = 'GET_INTEGRATION_LINKAGE_SUCCESS'
export const GET_INTEGRATION_LINKAGE_FAILURE = 'GET_INTEGRATION_LINKAGE_FAILURE'
export const UPDATE_INTEGRATION_LINKAGE_REQUEST = 'UPDATE_INTEGRATION_LINKAGE_REQUEST'
export const UPDATE_INTEGRATION_LINKAGE_SUCCESS = 'UPDATE_INTEGRATION_LINKAGE_SUCCESS'
export const UPDATE_INTEGRATION_LINKAGE_FAILURE = 'UPDATE_INTEGRATION_LINKAGE_FAILURE'
export const DELETE_INTEGRATION_LINKAGE_REQUEST = 'DELETE_INTEGRATION_LINKAGE_REQUEST'
export const DELETE_INTEGRATION_LINKAGE_SUCCESS = 'DELETE_INTEGRATION_LINKAGE_SUCCESS'
export const DELETE_INTEGRATION_LINKAGE_FAILURE = 'DELETE_INTEGRATION_LINKAGE_FAILURE'
export const GET_INTEGRATION_LINKAGE_LENDERS_REQUEST = 'GET_INTEGRATION_LINKAGE_LENDERS_REQUEST'
export const GET_INTEGRATION_LINKAGE_LENDERS_SUCCESS = 'GET_INTEGRATION_LINKAGE_LENDERS_SUCCESS'
export const GET_INTEGRATION_LINKAGE_LENDERS_FAILURE = 'GET_INTEGRATION_LINKAGE_LENDERS_FAILURE'
export const GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_REQUEST = 'GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_REQUEST'
export const GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_SUCCESS = 'GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_SUCCESS'
export const GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_FAILURE = 'GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_FAILURE'
export const GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_REQUEST = 'GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_REQUEST'
export const GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_SUCCESS = 'GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_SUCCESS'
export const GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_FAILURE = 'GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_FAILURE'
export const GET_ALL_WEBHOOK_INTEGRATIONS_REQUEST = 'GET_ALL_WEBHOOK_INTEGRATIONS_REQUEST'
export const GET_ALL_WEBHOOK_INTEGRATIONS_SUCCESS = 'GET_ALL_WEBHOOK_INTEGRATIONS_SUCCESS'
export const GET_ALL_WEBHOOK_INTEGRATIONS_FAILURE = 'GET_ALL_WEBHOOK_INTEGRATIONS_FAILURE'

// INDIVIDUAL COVERAGE
export const GET_APPRAISERS_COVERAGE_REQUEST = 'GET_APPRAISERS_COVERAGE_REQUEST'
export const GET_APPRAISERS_COVERAGE_SUCCESS = 'GET_APPRAISERS_COVERAGE_SUCCESS'
export const GET_APPRAISERS_COVERAGE_FAILURE = 'GET_APPRAISERS_COVERAGE_FAILURE'


// GET COMPANY DETAIL
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS'
